import React, { useState, useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import FileDownloadIcon from '../../Images/Excel2_24px.png';
import ContentCopyIcon from "../../Images/Copy.svg";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./Chatbot.css";
import * as XLSX from "xlsx";

function ChatGrid({ response, responseType }) {
    const [rowData, setRowData] = useState([]);
    const [colDefs, setColDefs] = useState([]);
    const gridRef = useRef();

    useEffect(() => {
        try{
            if (responseType === "list") {
                let rows = response;
                let columnDefs = getColumnDefs(response);
                setRowData(rows);
                setColDefs(columnDefs);
            }
            if (responseType === "objectWithList") {
                const arrayKey = Object.keys(response).find((key) => Array.isArray(response[key]));
                let rows = response[arrayKey];
                let columnDefs = getColumnDefs(response[arrayKey]);
                setRowData(rows);
                setColDefs(columnDefs);
            }
        }
        catch(e){
            setRowData([]);
            setColDefs([]);
        }
    }, [response, responseType]);

    const headerNameFormat = (item) => 
    item.replace(/_/g, " ") // Replace underscores with spaces
        .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between camel case transitions
        .trim(); // Ensure no leading/trailing spaces


    const getColumnDefs = (data) => {
        const columns = Object.keys(data[0]);

    let stringColumns = [];
    let numericColumns = [];

    columns.forEach((col) => {
        const allValues = data.map((row) => row[col]);
        const isNumeric = allValues.some(value => typeof value === "number"); // Check if any value is numeric
        const isPercentageColumn = allValues.some(value => typeof value === "number" && value.toString().includes("."));
        const isHiddenColumn = allValues.every(value => typeof value === "number" && value >= 1);

        if (isHiddenColumn) return;

        const colDef = {
            headerName: headerNameFormat(col),
            field: col,
            valueFormatter: (params) => {
                if (isPercentageColumn && typeof params.value === "number") {
                    return new Intl.NumberFormat("en-US", {
                        style: "percent",
                        minimumFractionDigits: 2
                    }).format(params.value);
                }
                return params.value;
            },
            flex: 1
        };

        if (isNumeric) {
            numericColumns.push(colDef);
        } else {
            stringColumns.push(colDef);
        }
    });

    // Ensure string columns are at the start and numerical columns follow, avoiding the first position
    return [...stringColumns, ...numericColumns];
    };

    const copyToClipboard = () => {
      if (!gridRef.current) return;
      
      gridRef.current.api.selectAll(); 
      gridRef.current.api.copySelectedRowsToClipboard({ includeHeaders: true });
      gridRef.current.api.deselectAll(); 
  };
  

    const exportToExcel = () => {
        if (!gridRef.current) return;

        gridRef.current.api.selectAll(); 
        gridRef.current.api.copySelectedRowsToClipboard({ includeHeaders: true });

        setTimeout(() => {
            navigator.clipboard.readText().then((clipboardData) => {
                const rows = clipboardData.split("\n").map(row => row.split("\t"));
                const ws = XLSX.utils.aoa_to_sheet(rows);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Exported Data");

                XLSX.writeFile(wb, "Exported_Data.xlsx");
                gridRef.current.api.deselectAll();
            });
        }, 100);
    };

    return (
        <> {rowData.length > 0 && <>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginBottom: "5px" }}>
                <button className="rounded-button" onClick={copyToClipboard} disabled={rowData.length === 0}>
                    <img className="py-2 SBA_hand" src={ContentCopyIcon} />
                </button>
                <button className="rounded-button" onClick={exportToExcel} disabled={rowData.length === 0}>
                    <img className="py-2 SBA_hand" src={FileDownloadIcon} />
                </button>
            </div>

            <div className="ag-theme-alpine m-1" style={{ width: "100%" }}>
                <AgGridReact ref={gridRef} rowData={rowData} columnDefs={colDefs} rowSelection="multiple" defaultColDef={{ resizable: true }} />
            </div>
        </>
        }
        </>
    );
}

export default ChatGrid;
